import { render, staticRenderFns } from "./PendingViz.vue?vue&type=template&id=f0644108&scoped=true"
import script from "./PendingViz.vue?vue&type=script&lang=js"
export * from "./PendingViz.vue?vue&type=script&lang=js"
import style0 from "./PendingViz.vue?vue&type=style&index=0&id=f0644108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0644108",
  null
  
)

export default component.exports